import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {
  isMobile: boolean;
  isIos: boolean;

  constructor(private appStateSrv: AppStateProvider) {
    this.isMobile = this.appStateSrv.isMobileDevice();
  }

  ngOnInit(): void {

    let ref=document.getElementsByTagName("body")[0];
      if(this.appStateSrv.checkOS()=="Android")
        ref.style.fontFamily='Roboto'
      else
      ref.style.fontFamily='SF Pro Text';



  }


}
